// Pickup terms shown across the cart, checkout and confirmation pages.
//
// These are duplicated in lambda/order-handler/index.js for the order emails —
// change them in both places, or the site and the emails will disagree about
// where and when a customer should collect.

export const PICKUP_STREET = '13514 Glen Harwell Rd #B2';
export const PICKUP_CITY = 'Dover, FL 33527';
export const PICKUP_ADDRESS = `${PICKUP_STREET}, ${PICKUP_CITY}`;
export const PICKUP_MAPS_URL =
  'https://maps.google.com/?q=13514+Glen+Harwell+Rd+B2,+Dover,+FL+33527';

export const PICKUP_HOURS = 'Mon–Sat, 9am–5pm';

/** How long a ready order is held before we chase the customer. */
export const HOLD_DAYS = 7;

/**
 * Accepted at the counter. State the exclusion as well as the list — someone
 * turning up with only a card is the failure this line exists to prevent.
 */
export const PAYMENT_METHODS = 'cash, Zelle, Venmo or CashApp';
export const PAYMENT_EXCLUSION = "We can't take card payments.";

export const BUSINESS_PHONE = '(251) 751-5962';
export const BUSINESS_PHONE_HREF = 'tel:2517515962';
export const BUSINESS_EMAIL = 'inquiries@tampabeesupply.com';
